import * as yup from "yup";

import { ocMessage, requiredMessage } from "../validationMessages";
import { ocValidator, ocValidatorOptional } from "../validationRegex";

import { trimmedString } from "./trimmedString";

export const ocNumberValidator = trimmedString.matches(ocValidatorOptional, {
  excludeEmptyString: true,
  message: ocMessage,
});
export const ocNumberValidatorRequired = trimmedString
  .required(requiredMessage)
  .matches(ocValidator, ocMessage);
export const ocNumberOrRelation = yup.string().test(function (value) {
  const { registrationNumber } = this.parent;

  if (!registrationNumber) {
    try {
      ocNumberValidatorRequired.validateSync(value);
      return true;
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      return this.createError({ message, path: this.path });
    }
  }
  return true;
});
